import { createAuthClient } from "better-auth/react";

/** Same origin as the page; /api/auth is proxied (dev) or service-bound (prod) to the API Worker. */
export const authClient = createAuthClient({
  baseURL: window.location.origin,
  basePath: "/api/auth",
});

export const { useSession, signIn, signUp, signOut } = authClient;

/**
 * Where the email-verification link lands after Better Auth sets the session.
 * /login sees the fresh session and forwards to the redirect target; on a bad
 * token Better Auth appends `?error=…` to the same URL, which /login renders.
 */
export function verifyCallbackURL(target?: string) {
  return target ? `/login?redirect=${encodeURIComponent(target)}` : "/login";
}

export type Session = NonNullable<ReturnType<typeof useSession>["data"]>;
